<div class="card">
    <div class="card-body">
        <mat-horizontal-stepper [linear]="isLinear" #stepper>
            <mat-step [stepControl]="InformationGeneral">
                <form [formGroup]="InformationGeneral">
                    <ng-template matStepLabel>Información General</ng-template>
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="form-group col-md-8">
                                    <label>Titulo</label>
                                    <input type="text" class="form-control" formControlName="cou_vc_name">
                                </div>
                                <div class="form-group col-md-4">
                                    <label>Categoria</label>
                                    <select class="form-control" formControlName="cou_in_category">
                                        <option value="">SELECCIONAR</option>
                                        <ng-container *ngFor="let parameter of parameters">
                                            <option *ngIf="parameter.sys_in_group==500"
                                                [ngValue]="parameter.sys_in_parameter">{{parameter.sys_vc_description}}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-3">
                                    <label>Tipo de Duración</label>
                                    <select class="form-control" formControlName="cou_in_duration_type">
                                        <option value="">SELECCIONAR</option>
                                        <ng-container *ngFor="let parameter of parameters">
                                            <option *ngIf="parameter.sys_in_group==600"
                                                [ngValue]="parameter.sys_in_parameter">{{parameter.sys_vc_description}}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label>Duración del curso</label>
                                    <input type="text" class="form-control" formControlName="cou_in_duration">
                                </div>

                                <div class="form-group col-md-3">
                                    <label>Pago</label>
                                    <select class="form-control" formControlName="cou_in_payment_method">
                                        <option value="">SELECCIONAR</option>
                                        <ng-container *ngFor="let parameter of parameters">
                                            <option *ngIf="parameter.sys_in_group==700"
                                                [ngValue]="parameter.sys_in_parameter">{{parameter.sys_vc_description}}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                 
                                <div class="form-group col-md-2">
                                    <label>Costo Soles</label>
                                    <input type="text" class="form-control" formControlName="cou_do_soles_cost">

                                </div>
                                <div class="form-group col-md-2">
                                    <label>Costo Dolar</label>
                                    <input type="text" class="form-control" formControlName="cou_do_dollar_cost">

                                </div>
                            </div>


                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Descripcion</label>
                                    <textarea class="form-control" formControlName="cou_tx_description"></textarea>
                                    <!--  <angular-editor [config]="editorConfig" formControlName="cou_tx_description"></angular-editor>-->
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Que vas aprender</label>
                                    <textarea class="form-control" formControlName="cou_tx_learn"></textarea>
                                    <!-- <angular-editor [config]="editorConfig" formControlName="cou_tx_learn"></angular-editor>-->
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>A quienes van dirigidos</label>
                                    <textarea class="form-control" formControlName="cou_tx_addressed"></textarea>
                                    <!-- <angular-editor [config]="editorConfig" formControlName="cou_tx_addressed"></angular-editor> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button mat-button matStepperNext (click)="NextCourses();">Siguiente</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [editable]="isEditable">
                <ng-template matStepLabel>Complementos</ng-template>
                <app-assign-files-course [cou_vc_uri_folder]="InformationGeneral.controls['cou_vc_uri_folder'].value" [cou_in_id]="InformationGeneral.controls['cou_in_id'].value">
                </app-assign-files-course>
            </mat-step>

            <mat-step [editable]="isEditable">
                <ng-template matStepLabel>Modulos</ng-template>
                <app-modules-add [cou_in_id]="InformationGeneral.controls['cou_in_id'].value"
                    (SendDataModule)="LoadDataModule($event)"></app-modules-add>
            </mat-step>

            <mat-step [editable]="isEditable">
                <ng-template matStepLabel>Videos</ng-template>
                <app-movies [moduleList]="moduleList" [movieList]="movieList" [default_select_module]="default_select_module"
                    [cou_in_id]="InformationGeneral.controls['cou_in_id'].value"
                    [cou_vc_uri_folder]="InformationGeneral.controls['cou_vc_uri_folder'].value" #movies></app-movies>
            </mat-step>


            <mat-step [editable]="isEditable">
                <ng-template matStepLabel>Cuestionario</ng-template>
                <app-questions-add [moduleList]="moduleList" [default_select_module]="default_select_module"
                    [cou_in_id]="InformationGeneral.controls['cou_in_id'].value" #questions></app-questions-add>
            </mat-step>
            <!--
            <mat-step>
                <ng-template matStepLabel>Resumen</ng-template>
                <p>You are now done.</p>
                <div>
                    <button mat-button matStepperPrevious>Back</button>
                    <button mat-button (click)="stepper.reset()">Reset</button>
                </div>
            </mat-step>
-->
        </mat-horizontal-stepper>
    </div>
</div>